import translations from "translations";
import { AuthenticationInfo, DefaultAuthenticationInfo } from "./AuthenticationInfo";
import { SpIdProfileDto } from "services/apis/types/account/SpIdProfileDto";
import { LocalStorageUser } from "services/appContext/LocalStorageUser";
import { DefaultOrderDetails, Orders } from "./Orders";
import { DefaultWorkQueueDetails, WorkQueue } from "./WorkQueue";
import { ProvisionOrderListDto } from "services/apis/types/order/ProvisionOrderListDto";

export type LocalStorageInfo = {
  authenticationInfo: AuthenticationInfo;
  language: keyof typeof translations;
  selectedProfile?: SpIdProfileDto;
  user?: LocalStorageUser;
  orders?: Orders;
  workQueue?: WorkQueue;
  hasTokenIdentifier?: boolean;
  provisionOrders?: ProvisionOrderListDto[];
  timerStartTime?: any;
  startTime?: string;
  duration?: string;
};

export const DefaultLocalStorageInfo: LocalStorageInfo = {
  authenticationInfo: DefaultAuthenticationInfo,
  language: "en",
  orders: DefaultOrderDetails,
  workQueue: DefaultWorkQueueDetails,
  hasTokenIdentifier: false,
  provisionOrders: [],
  timerStartTime: ""
};
